import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "trim"})
export class TrimPipe implements PipeTransform {
    transform(value: string) {
        if (typeof value !== "string") {
            console.error("TrimPipe: value is not a string", value);
            return "";
        }
        return value?.trim() ?? "";
    }
}
